// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"ss_a bhc_b bhc_bj","SubscribedPhotoblogs__link":"ss_b bhc_a bhc_r"};